import { getSafeAreaPadding } from '../../utils/safeArea'
import { Button } from './Button'

interface EmptyStateProps {
  icon?: string
  title?: string
  message: string
  action?: {
    label: string
    onClick: () => void
  }
  fullScreen?: boolean
}

/**
 * Reusable empty state component for 'no data' scenarios
 *
 * @example
 * <EmptyState
 *   icon="📝"
 *   message="No trainings found"
 *   action={{ label: "Create Training", onClick: handleCreate }}
 * />
 */
export function EmptyState({
  icon = '📝',
  title,
  message,
  action,
  fullScreen = false
}: EmptyStateProps) {
  const content = (
    <div className="text-center py-10">
      <div className="text-5xl mb-4">{icon}</div>
      {title && <h3 className="text-xl font-bold mb-2 opacity-90">{title}</h3>}
      <p className="text-base opacity-70 mb-6">{message}</p>
      {action && (
        <Button type="button" variant="primary" size="md" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={getSafeAreaPadding()}
      >
        {content}
      </div>
    )
  }

  return content
}
